module.exports = __webpack_public_path__ + "static/media/MW.317a10f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MW.svg
// module id = 2218
// module chunks = 7